import React, { useState } from 'react';
import Sidebar from '../../partials/Sidebar';
import Header from '../../partials/Header';
import OrgsTable from '../../partials/orgs/OrgsTable';
import OrgsSidebar from '../../partials/orgs/OrgsSidebar';

function Orgs() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [organizationsSidebarOpen, setOrganizationsSidebarOpen] = useState(false);
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [selectedType, setSelectedType] = useState('business');
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        {/* Site header */}
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        <main>
          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            {/* Page header */}
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
              <div className="mb-4 sm:mb-0">
                <h1 className="text-2xl text-slate-800 dark:text-slate-100 font-bold">Organization Management</h1>
              </div>
              
              {/* Organization type selector */}
              <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                <div className="relative inline-flex">
                  <select
                    className="form-select pl-3 pr-8 py-2 border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 focus:ring-indigo-500 dark:focus:ring-indigo-500/30"
                    value={selectedType}
                    onChange={(e) => setSelectedType(e.target.value)}
                  >
                    <option value="business">Businesses</option>
                    <option value="regulator">Regulators</option>
                  </select>
                </div>
                
                {/* Add organization button */}
                <button
                  className="btn bg-indigo-500 hover:bg-indigo-600 text-white"
                  onClick={() => { setSelectedOrganization(null); setOrganizationsSidebarOpen(true); }}
                >
                  <svg className="w-4 h-4 fill-current opacity-50 shrink-0" viewBox="0 0 16 16">
                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                  </svg>
                </button>
              </div>
            </div>
            
            {/* Table */}
            <OrgsTable
              organizationType={selectedType}
              setOrganizationsSidebarOpen={setOrganizationsSidebarOpen}
              setSelectedOrganization={setSelectedOrganization}
              refreshKey={refreshKey}
              onRefresh={() => setRefreshKey(k => k + 1)}
            />
          </div>
        </main>
      </div>
      
      {/* Organization sidebar */}
      <OrgsSidebar
        organizationsSidebarOpen={organizationsSidebarOpen}
        setOrganizationsSidebarOpen={setOrganizationsSidebarOpen}
        organizationType={selectedType}
        selectedOrganization={selectedOrganization}
        onSaved={() => setRefreshKey(k => k + 1)}
      />
    </div>
  );
}

export default Orgs;